export default __webpack_public_path__ + "static/media/unlink.fd9e92f7.svg";